<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-08 18:39:46
 * @LastEditTime: 2022-03-01 21:25:08
 * @LastEditors: chenguobiao
-->
<template>
  <div class="dialog" v-if="visible">
    <div class="dialog__masker"></div>
    <div class="dialog__box">
      <div class="dialog__title">
        <span class="line--bar"></span><span>平台介绍</span
        ><span class="line--bar"></span>
      </div>
      <div class="dialog__info">
        <div class="row introduce">
          为了您能更好的使用本考级平台，请先观看平台使用说明，建议下载视频观看！
        </div>
      </div>
      <div class="dialog__options">
        <div class="button--list">
          <div class="apply--button" @click="play">观看视频<div class="icon--image"><img src="@/render/assets/images/home/icon_play.png" /></div></div>
          <a class="apply--button" href="/upload/introduce.mp4" download="introduce.mp4">下载视频<div class="icon--image rotate"><img src="@/render/assets/images/home/icon_play.png" /></div></a>
          <!-- <div class="apply--button" @click="download">下载视频<div class="icon--image rotate"><img src="@/render/assets/images/home/icon_play.png" /></div></div> -->
        </div>
        <div class="close" @click="handleClose">
          <img src="@/render/assets/images/home/close_grading_notice.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from './mixin'
import { homeAPI } from '@/apis'
export default {
  mixins: [dialogMixin],
  props: {},
  methods: {
    play() {
      window.open('/upload/introduce.mp4')
    },
    handleClose() {
      this.handleUpdateVideoTimes()
      this.close()
    },
    handleUpdateVideoTimes () {
      homeAPI.postUpdateVideoTimes()
    }
  },
}
</script>

<style lang="scss" scoped>
@import './dialog.scss';
.dialog {
  &__box {
    padding: val(24) 0 val(46);
    width: val(500);
    height: val(200);
    background: url('../../assets/images/home/introduce_dialog_bg.png')
      no-repeat left top;
    background-size: 100%;
  }
  &__title {
    margin-bottom: val(46);
    text-align: center;
    font-size: val(24);
    line-height: val(24);
    color: #b16012;
    display: flex;
    justify-content: center;
    align-items: center;
    .line--bar {
      margin: 0 val(10);
      width: val(20);
      height: val(1);
      background: url(../../assets/images/home/line_bar.png) left top no-repeat;
      background-size: 100%;
      &:first-of-type {
        transform: rotate(180deg);
      }
    }
  }
  &__info .row {
    &.introduce {
      width: 80%;
      margin: 0 auto;
      text-align: center;
      font-size: val(16);
      line-height: val(21);
      color: #502700;
    }
  }
  &__options {
    position: absolute;
    bottom: val(28);
    left: 0;
    right: 0;
    transform: translateY(100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    .button--list {
      display: flex;
      justify-content: center;
      align-items: center;
      .apply--button {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-bottom: val(7);
        width: val(168);
        line-height: val(56);
        text-align: center;
        border-radius: val(37);
        background: linear-gradient(360deg, #b26113 0%, #fdae5f 100%);
        font-size: val(24);
        color: #ffffff;
        text-shadow: 3.773547887802124px 3.2802951335906982px 9px
          rgba(178, 94, 12, 0.3);
        &:first-child {
          margin-right: val(24);
        }
        .icon--image {
          margin-left: val(10);
          width: val(15);
          &.rotate {
            transform: rotate(90deg);
          }
        }
      }
    }

    .close {
      cursor: pointer;
      width: val(42);
    }
  }
}
</style>
